<template>
  <v-sheet width="600" class="px-16 pt-8 pb-6">
    <!-- 제목 -->
    <p class="mb-6 font-weight-bold text-center text-h5">직원 수정</p>

    <!-- 입력란 -->
    <v-sheet class="mt-2 px-4">
      <!-- 유형 -->
      <v-select class="rounded-lg mb-4" label="유형" dense outlined hide-details :items="select_list.type" item-text="label" item-value="value" v-model="type"></v-select>

      <!-- 이름 (다국어) -->
      <div class="mb-4">
        <div class="font-weight-medium mb-2">이름</div>
        <v-text-field class="rounded-lg mb-2" label="이름 (한글)" dense outlined hide-details v-model="name_kr"></v-text-field>
        <v-text-field class="rounded-lg mb-2" label="이름 (영어)" dense outlined hide-details v-model="name_en"></v-text-field>
        <v-text-field class="rounded-lg" label="이름 (일어)" dense outlined hide-details v-model="name_jp"></v-text-field>
      </div>

      <!-- 아이디 -->
      <v-text-field class="rounded-lg mb-4" label="아이디" dense outlined hide-details v-model="user_id"></v-text-field>

      <v-text-field class="rounded-lg mb-4" label="휴대폰번호" dense outlined hide-details v-model="phoneNumber" type="number" hide-spin-buttons></v-text-field>

      <v-select class="rounded-lg mb-6" label="지점" dense outlined hide-details :items="branchList" item-text="displayText" item-value="id" v-model="branchId" clearable></v-select>

      <div class="mb-2">
        <div class="font-weight-medium mb-2">프로필 이미지</div>
        <v-sheet outlined class="rounded-lg mb-3 profile-preview d-flex align-center justify-center">
          <v-img :src="profileImagePreviewSrc" contain height="150">
            <template v-slot:placeholder>
              <div class="grey--text text--darken-1 text-caption preview-placeholder">이미지 미리보기</div>
            </template>
          </v-img>
        </v-sheet>
        <v-sheet class="profile-dropzone mb-2" @drop.prevent="handleDrop" @dragover.prevent>
          <v-file-input class="rounded-lg" outlined dense show-size hide-details prepend-icon color="primary" label="프로필 이미지" v-model="uploadImage" accept="image/*" @change="onFileChange">
            <template v-slot:prepend-inner>
              <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
            </template>
          </v-file-input>
        </v-sheet>
        <v-btn text small color="grey darken-1" class="px-2" @click="clearProfileImage" v-if="hasProfileImage">이미지 초기화</v-btn>
      </div>

      <div class="mb-2">
        <div class="font-weight-medium mb-2">작가 소개 이미지 (1500 x 600)</div>
        <v-sheet outlined class="rounded-lg mb-3 staff-preview d-flex align-center justify-center">
          <v-img :src="staffImagePreviewSrc" contain height="240">
            <template v-slot:placeholder>
              <div class="grey--text text--darken-1 text-caption preview-placeholder">이미지 미리보기</div>
            </template>
          </v-img>
        </v-sheet>
        <v-sheet class="staff-dropzone mb-2" @drop.prevent="handleStaffDrop" @dragover.prevent>
          <v-file-input
            class="rounded-lg"
            outlined
            dense
            show-size
            hide-details
            prepend-icon
            color="primary"
            label="작가 소개 이미지"
            v-model="uploadStaffImage"
            accept="image/*"
            @change="onStaffFileChange"
          >
            <template v-slot:prepend-inner>
              <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
            </template>
          </v-file-input>
        </v-sheet>
        <v-btn text small color="grey darken-1" class="px-2" @click="clearStaffImage" v-if="hasStaffImage">이미지 초기화</v-btn>
      </div>

      <!-- 소개 문구 (다국어) -->
      <div class="mb-4">
        <div class="font-weight-medium mb-2">소개 문구</div>
        <v-textarea
          class="rounded-lg mb-2"
          label="소개 문구 (한글)"
          outlined
          auto-grow
          dense
          rows="3"
          hide-details
          v-model="introduction_kr"
          placeholder="작가 소개 문구를 입력해주세요."
        ></v-textarea>
        <v-textarea
          class="rounded-lg mb-2"
          label="소개 문구 (영어)"
          outlined
          auto-grow
          dense
          rows="3"
          hide-details
          v-model="introduction_en"
          placeholder="Enter staff introduction."
        ></v-textarea>
        <v-textarea
          class="rounded-lg"
          label="소개 문구 (일어)"
          outlined
          auto-grow
          dense
          rows="3"
          hide-details
          v-model="introduction_jp"
          placeholder="スタッフ紹介を入力してください。"
        ></v-textarea>
      </div>
    </v-sheet>

    <!-- 버튼 -->
    <div class="d-flex justify-center mt-8">
      <!-- 취소 -->
      <v-btn width="100" color="grey lighten-3" depressed class="font-weight-bold rounded-10 mr-3" @click="close()"> 닫기 </v-btn>

      <!-- 수정 -->
      <v-btn width="100" dark depressed class="font-weight-bold rounded-10" @click="submit()"> 수정 </v-btn>
    </div>
  </v-sheet>
</template>
<script>
export default {
  props: ["selectedItem"],

  data: () => ({
    select_list: {
      type: [
        { label: "관리자", value: "admin" },
        { label: "메이커", value: "staff" },
      ],
      receiveTalk: ["Y", "N"],
    },

    type: "",
    name_kr: "",
    name_en: "",
    name_jp: "",
    user_id: "",
    phoneNumber: "",
    branchId: null,
    branchList: [],
    receiveTalk: "N",
    uploadImage: null,
    profileImage: "",
    profileImagePreview: "",
    profileImageChanged: false,
    uploadStaffImage: null,
    staffImage: "",
    staffImagePreview: "",
    staffImageChanged: false,
    introduction_kr: "",
    introduction_en: "",
    introduction_jp: "",
  }),

  async mounted() {
    await this.loadBranches()
    this.type = this.selectedItem.type
    this.user_id = this.selectedItem.user_id
    this.phoneNumber = this.selectedItem.phoneNumber
    this.branchId = this.selectedItem.defaultBranchId || null
    this.profileImage = this.selectedItem.profile_image || ""
    this.staffImage = this.selectedItem.profile_staff_image || ""

    // 이름 파싱 (JSON 타입이면 분리, 아니면 한글 입력값으로)
    this.parseNameField(this.selectedItem.name)

    // 소개 파싱 (JSON 타입이면 분리, 아니면 한글 입력값으로)
    this.parseIntroductionField(this.selectedItem.introduction)
  },

  beforeDestroy() {
    this.resetProfileImageState()
    this.resetStaffImageState()
  },

  computed: {
    profileImagePreviewSrc() {
      if (this.profileImagePreview) {
        return this.profileImagePreview
      }
      if (this.profileImage) {
        return this.buildProfileImageUrl(this.profileImage)
      }
      return "/upload/user/profile_image/default.png"
    },
    hasProfileImage() {
      return !!(this.profileImagePreview || (this.profileImage && this.profileImage !== "default.png"))
    },
    staffImagePreviewSrc() {
      if (this.staffImagePreview) {
        return this.staffImagePreview
      }
      if (this.staffImage) {
        return this.buildStaffImageUrl(this.staffImage)
      }
      return ""
    },
    hasStaffImage() {
      return !!(this.staffImagePreview || this.staffImage)
    },
  },

  methods: {
    parseNameField(value) {
      if (!value) {
        this.name_kr = ""
        this.name_en = ""
        this.name_jp = ""
        return
      }

      try {
        const parsed = JSON.parse(value)
        if (typeof parsed === "object" && parsed !== null) {
          this.name_kr = parsed.kr || ""
          this.name_en = parsed.en || ""
          this.name_jp = parsed.jp || ""
        } else {
          this.name_kr = value
          this.name_en = ""
          this.name_jp = ""
        }
      } catch (e) {
        // JSON이 아니면 한글 입력값으로 처리
        this.name_kr = value
        this.name_en = ""
        this.name_jp = ""
      }
    },

    parseIntroductionField(value) {
      if (!value) {
        this.introduction_kr = ""
        this.introduction_en = ""
        this.introduction_jp = ""
        return
      }

      try {
        const parsed = JSON.parse(value)
        if (typeof parsed === "object" && parsed !== null) {
          this.introduction_kr = parsed.kr || ""
          this.introduction_en = parsed.en || ""
          this.introduction_jp = parsed.jp || ""
        } else {
          this.introduction_kr = value
          this.introduction_en = ""
          this.introduction_jp = ""
        }
      } catch (e) {
        // JSON이 아니면 한글 입력값으로 처리
        this.introduction_kr = value
        this.introduction_en = ""
        this.introduction_jp = ""
      }
    },

    async loadBranches() {
      try {
        const { data } = await this.$http.get("/api/admin/branch")
        this.branchList = (data?.branches || []).map((branch) => ({
          id: branch.id,
          displayText: `${branch.name} (${branch.branchCode})`,
        }))
      } catch (error) {
        console.error("branch load error", error)
      }
    },

    // 취소
    close() {
      // 값 초기화
      this.type = ""
      this.name_kr = ""
      this.name_en = ""
      this.name_jp = ""
      this.user_id = ""
      this.branchId = null
      this.introduction_kr = ""
      this.introduction_en = ""
      this.introduction_jp = ""
      this.resetProfileImageState()
      this.resetStaffImageState()
      this.$emit("close")
    },

    // 수정
    async submit() {
      if (this.type == "") {
        alert("직원 유형을 선택해주세요.")
      } else if (this.name_kr == "") {
        alert("이름(한글)을 입력해주세요.")
      } else if (this.user_id == "") {
        alert("아이디를 입력해주세요.")
      } else {
        const profileImagePayload = await this.uploadProfileImageIfNeeded()
        const staffImagePayload = await this.uploadStaffImageIfNeeded()

        // 이름 JSON 생성
        const namePayload = JSON.stringify({
          kr: this.name_kr || "",
          en: this.name_en || "",
          jp: this.name_jp || "",
        })

        // 소개 JSON 생성
        const hasIntroduction = this.introduction_kr || this.introduction_en || this.introduction_jp
        const introductionPayload = hasIntroduction
          ? JSON.stringify({
              kr: this.introduction_kr || "",
              en: this.introduction_en || "",
              jp: this.introduction_jp || "",
            })
          : null

        this.$http
          .post("/api/admin/staff/update", {
            params: {
              type: this.type,
              name: namePayload,
              user_id: this.user_id,
              id: this.selectedItem.id,
              phoneNumber: this.phoneNumber ? this.phoneNumber : null,
              branchId: this.branchId || null,
              introduction: introductionPayload,
              ...(profileImagePayload !== undefined ? { profile_image: profileImagePayload } : {}),
              ...(staffImagePayload !== undefined ? { profile_staff_image: staffImagePayload } : {}),
            },
          })
          .then((res) => {
            if (res.data.affectedRows) {
              alert("직원이 정상적으로 수정되었습니다.")
              this.$emit("close")
              this.$emit("updated")
            } else {
              alert("직원을 수정하는 도중 오류가 발생하였습니다.")
            }
          })
      }
    },

    buildProfileImageUrl(filename) {
      return filename && filename.includes("/") ? filename : `/upload/user/profile_image/${filename}`
    },

    buildStaffImageUrl(filename) {
      return filename && filename.includes("/") ? filename : `/upload/user/profile_image/${filename}`
    },

    onFileChange() {
      if (this.uploadImage instanceof File) {
        this.setUploadFile(this.uploadImage)
      } else {
        this.profileImagePreview = ""
      }
    },

    handleDrop(e) {
      const file = e?.dataTransfer?.files?.[0]
      if (file) {
        this.setUploadFile(file)
      }
    },

    setUploadFile(file) {
      if (!(file instanceof File)) {
        return
      }
      if (this.profileImagePreview) {
        URL.revokeObjectURL(this.profileImagePreview)
      }
      this.uploadImage = file
      this.profileImagePreview = URL.createObjectURL(file)
      this.profileImageChanged = true
    },

    clearProfileImage() {
      if (this.profileImagePreview) {
        URL.revokeObjectURL(this.profileImagePreview)
      }
      this.profileImagePreview = ""
      this.uploadImage = null
      this.profileImage = "default.png"
      this.profileImageChanged = true
    },

    resetProfileImageState() {
      if (this.profileImagePreview) {
        URL.revokeObjectURL(this.profileImagePreview)
      }
      this.uploadImage = null
      this.profileImagePreview = ""
      this.profileImageChanged = false
      this.profileImage = ""
    },

    onStaffFileChange() {
      if (this.uploadStaffImage instanceof File) {
        this.setUploadStaffFile(this.uploadStaffImage)
      } else {
        this.staffImagePreview = ""
      }
    },

    handleStaffDrop(e) {
      const file = e?.dataTransfer?.files?.[0]
      if (file) {
        this.setUploadStaffFile(file)
      }
    },

    setUploadStaffFile(file) {
      if (!(file instanceof File)) {
        return
      }
      if (this.staffImagePreview) {
        URL.revokeObjectURL(this.staffImagePreview)
      }
      this.uploadStaffImage = file
      this.staffImagePreview = URL.createObjectURL(file)
      this.staffImageChanged = true
    },

    clearStaffImage() {
      if (this.staffImagePreview) {
        URL.revokeObjectURL(this.staffImagePreview)
      }
      this.staffImagePreview = ""
      this.uploadStaffImage = null
      this.staffImage = ""
      this.staffImageChanged = true
    },

    resetStaffImageState() {
      if (this.staffImagePreview) {
        URL.revokeObjectURL(this.staffImagePreview)
      }
      this.uploadStaffImage = null
      this.staffImagePreview = ""
      this.staffImageChanged = false
      this.staffImage = ""
    },

    async uploadProfileImageIfNeeded() {
      if (this.uploadImage instanceof File) {
        const formData = new FormData()
        formData.append("image", this.uploadImage)
        try {
          const { data } = await this.$http.post("/api/image/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            params: {
              type: "profile_image",
            },
          })
          this.profileImage = data
          this.profileImageChanged = true
          this.uploadImage = null
          return data
        } catch (error) {
          console.error("profile image upload error", error)
          alert("이미지 업로드 중 오류가 발생했습니다.")
          return undefined
        }
      }

      if (this.profileImageChanged) {
        return this.profileImage || "default.png"
      }

      return undefined
    },

    async uploadStaffImageIfNeeded() {
      if (this.uploadStaffImage instanceof File) {
        const formData = new FormData()
        formData.append("image", this.uploadStaffImage)
        try {
          const { data } = await this.$http.post("/api/image/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            params: {
              type: "profile_image",
            },
          })
          this.staffImage = data
          this.staffImageChanged = true
          this.uploadStaffImage = null
          return data
        } catch (error) {
          console.error("staff image upload error", error)
          alert("작가 소개 이미지 업로드 중 오류가 발생했습니다.")
          return undefined
        }
      }

      if (this.staffImageChanged) {
        return this.staffImage || ""
      }

      return undefined
    },
  },
}
</script>
<style scoped>
.test {
  width: 100%;
  border: 1px solid red;
}

.test tr td,
.test tr th {
  border: 1px solid red;
}

.profile-preview {
  height: 160px;
}

.staff-preview {
  height: 250px;
}

.preview-placeholder {
  width: 100%;
  text-align: center;
}

.profile-dropzone {
  border: 1px dashed #c4c4c4;
  border-radius: 10px;
  padding: 4px 8px;
}

.staff-dropzone {
  border: 1px dashed #c4c4c4;
  border-radius: 10px;
  padding: 4px 8px;
}
</style>
<style scoped>
.v-data-table >>> th,
.v-data-table >>> td {
  min-width: 200px !important;
}
</style>
